import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  loaderService,
  ssDialogService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import controller from './edit-recommendation-comment-dialog.controller';
import template from './edit-recommendation-comment-dialog.html';
import nameTpl from '../messages/recommendation.name.messages.html';


class dialogService {
  getOptions($event, { recommendationId, recommendationCommentId, recommendationCommentText }) {
    return {
      controller,
      controllerAs: 'editRecommendationCommentDialogVM',
      locals: {
        recommendationId,
        recommendationCommentId,
        recommendationCommentText
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.auditTrail.editRecommendationCommentDialog', [
  alerts,
  amDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('editRecommendationCommentDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('recommendation.name.messages.html', nameTpl);
  })
  .name;
